export const Contacts = () => {
	return (
		<div id='contacts'>
			<a
				href='https://www.linkedin.com/in/musa-imad-issa-122114238/'
				target='_blank'
                rel='noreferrer'
            className='contact-link'
            >
				<div>LinkedIn</div>
			</a>
			<a
				href='mailto:musaissa004@gmail.com'
				target='_blank'
				rel='noreferrer'
                
                className='contact-link'    
            >
				<div>Email</div>
			</a>
            <a href='tel:Number'
            className='contact-link'
            >0772 100 2988</a>
            <a href='SMS:Number'
            className='contact-link'
            >SMS</a>
		</div>
	);
};
